<template>
  <div id="app">
    <Nav @change-locale="changeLocale" />
    <transition name="fade" mode="in">
      <router-view @change-locale="changeLocale" />
    </transition>
    <Footer />
    <LeftLayout />
    <RightLayout />
    <ButtonRed />
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";
import LeftLayout from "./components/LeftLayout.vue";
import RightLayout from "./components/RightLayout.vue";
import ButtonRed from "./components/ButtonRed.vue";

export default {
  components: {
    Nav,
    Footer,
    LeftLayout,
    RightLayout,
    ButtonRed,
  },
  methods: {
    changeLocale() {
      this.$i18n.locale = this.$i18n.locale === "ja" ? "fr" : "ja";
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap");
</style>
